export const REQUEST_SCAN_DETAILS_DATA = "REQUEST_SCAN_DETAILS_DATA";
export const RECEIVE_SCAN_DETAILS_DATA = "RECEIVE_SCAN_DETAILS_DATA";
export const NO_RESULTS_SCAN_DETAILS_DATA = 'NO_RESULTS_SCAN_DETAILS_DATA';
export const ERROR_RETRIEVING_SCAN_DETAILS_DATA = 'ERROR_RETRIEVING_SCAN_DETAILS_DATA';

export const requestScanDetailsData = payload => ({ type: REQUEST_SCAN_DETAILS_DATA, payload: payload });

export const receiveScanDetailsData = payload => ({ type: RECEIVE_SCAN_DETAILS_DATA, payload: payload });

export const noResultsScanDetailsData = payload => ({ type: NO_RESULTS_SCAN_DETAILS_DATA, payload: payload });

export const errorRetrievingScanDetailsData = error => ({ type: ERROR_RETRIEVING_SCAN_DETAILS_DATA, payload: error });



// WEBPACK FOOTER //
// ./src/actions/scanDetailsDataActions.js